export default "__VITE_ASSET__DHpisTZO__"